import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { TipoDocumento } from '../../../models/tipo-documento';
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { Venta } from '../../../models/venta';
import { ComprobanteService } from '../../../services/comprobante.service';
import { ParametroContabilidadService } from '../../../services/parametro-contabilidad.service';
import { Validation } from '../../../config/validation';
import { SessionService } from '../../../services/session.service';
import { Bodega } from '../../../models/bodega';
import { BodegaService } from '../../../services/bodega.service';
import { Cliente } from '../../../models/cliente';
import { ClienteService } from '../../../services/cliente.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ClienteModalComponent } from '../../modals/cliente-modal/cliente-modal.component';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';
import { ProformaModalComponent } from '../../modals/proforma-modal/proforma-modal.component';
import { ServicioModalComponent } from '../../modals/servicio-modal/servicio-modal.component';
import { VentaDetalle } from '../../../models/venta_detalle';
import { FormaPagoService } from '../../../services/forma-pago.service';
import { FormaPago } from '../../../models/forma-pago';
import { SweetMessage } from '../../../config/sweet-message';
import { VentaService } from '../../../services/venta.service';
import { ReporteModalComponent } from '../../../components/modals/reporte-modal/reporte-modal.component';
import { Caja } from '../../../models/caja';
import { CajaService } from '../../../services/caja.service';
import { ParametroService } from '../../../services/parametro.service';
import { FacturaModalComponent } from '../../../components/modals/factura-modal/factura-modal.component';
import { EmitirGuiaremisionVentaModalComponent } from '../../../components/modals/emitir-guiaremision-venta-modal/emitir-guiaremision-venta-modal.component';
import { BlockService } from '../../../services/block.service';
import * as moment from 'moment';
import * as numeral from 'numeral';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';
import { Cobro } from '../../../models/cobro';
import { CobroDetalle } from '../../../models/cobro_detalle';
import { ProformaService } from '../../../services/proforma.service';
import { Proforma } from '../../../models/proforma';
import { InventarioService } from '../../../services/inventario.service';
import { ProductoService } from '../../../services/producto.service';
import { VentaElectronica } from '../../../models/venta-electronica';
import { CbtContadorService } from '../../../services/cbt-contador.service';
import { ConfirmacionAnulacionModalComponent } from '../../../components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { Amortizacion } from '../../../models/amortizacion';
import { AmortizacionDetalle } from '../../../models/amortizacion_detalle';
//import { NumberFormatPipe } from '../../../pipes/number-format.pipe';
//import { format } from 'url';
import { DatosAdicionales } from '../../../models/datos-adicionales';
import { PreciosModalComponent } from '../../../components/modals/precios-modal/precios-modal.component';
import { PrecioAdicional } from '../../../models/precio_adicional';
import { ConfigService } from '../../../config/config-service';
import { ImageModalComponent } from '../../modals/image-modal/image-modal.component';
import { UtilsService } from '../../../services/utils.service';
import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';
import { LoteModalComponent } from '../../modals/lote-modal/lote-modal.component';
import { environment } from '../../../../environments/environment';
import { Transferencia } from '../../../models/transferencia';
import { ValidarCorreoService } from '../../../services/validar-correo.service';
import { Lote } from '../../../models/lote';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import { FormasPagoFacturacionService } from '../../../services/formaspagofacturacion.service'
import { FormaPagoFacturacion } from '../../../models/forma-pago-facturacion';
import { AsientoContable } from '../../../models/asiento-contable';
import { Compra } from '../../../models/compra';
import { ParametroContabilidad } from '../../../models/parametro-contabilidad';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { PeriodoContable } from '../../../models/periodo-contable';
import { SerieEgresoModalComponent } from '../../modals/serie-egreso-modal/serie-egreso-modal.component';

class Cuota{
    constructor(
        public valor: number = 0,
        public fecha: any = "",
    ){
        //
    }
}

@Component({
	selector: 'app-venta-add',
	templateUrl: './venta-add.component.html',
    styleUrls: ['./venta-add.component.css'],
    providers: [
        TipoComprobanteService,
        ComprobanteService,
        SessionService,
        BodegaService,
        ClienteService,
        FormaPagoService,
        VentaService,
        CajaService,
        ParametroService,
        BlockService,
        ProformaService,
        InventarioService,
        ProductoService,
        ValidarCorreoService,
        ImpuestoPorcentajeService,
        FormasPagoFacturacionService,
        ParametroContabilidadService,
        PeriodoContableService,
        //NumberFormatPipe,
    ]
})
export class VentaAddComponent implements OnInit {
    public tipos: Array<TipoDocumento>;
    public venta: Venta;
    public ventasDetalle: Array<VentaDetalle>;
    public vl: Validation;
    public validDateFecha: Boolean;
    public bodegas: Array<Bodega>;
    public bodegas_selected: Array<any>;
    public cliente: Cliente;
    public PreciosAdd: PrecioAdicional;
    public bsModalRef: BsModalRef;
    public IVA: number;
    public IVA_PARAM: number;
    public formasPago: Array<FormaPago>;
    public cambio: number;
    public total_pago: number;
    public msgSweet: SweetMessage;
    public loading = false;
    public cajas: Array<Caja>;
    public caja: Caja;
    public fecha_emision;
    public fecha_actual;
    public fecha_MesAnt;
    public isPrinted: boolean;
    public isMail: boolean;
    public ventaIdPrinted: String;
    public numero_autorizacion: String;
    public cobro: Cobro;
    public cheques: Array<Cheque>;
    public datos: Array<DatosAdicionales>
    public tarjetas: Array<Tarjeta>;
    public transferencias: Array<Transferencia>;
    public valorefectivo: number;
    public proforma: Proforma;
    public secuencial: number;
    public detalle: String;
    private venta_detalle: VentaDetalle;
    public Mod_FactElec: string;
    public Mod_Inventario: string;
    public Mod_Cartera: string;
    public Mod_Logistica: string;
    public Mod_Contabilidad: string;
    public Identif: string;
    public ventaElectronica: VentaElectronica;
    public is_numero_manual: boolean;
    public is_precios: boolean;
    public numero_documento: String;
    //public cuotas_credito: Array<Cuota>;
    public amortizacion: Amortizacion;
    public correos: Array<any>;
    public is_precio_unitario_editable: boolean;
    public if_uso_lote: boolean;
    public ruta_imagen: String;
    public config: ConfigService;
    public calculo_decimales: number;
    public numero_decimales: number;
    public format_decimal: String;
    @ViewChild(DatosPagosComponent) datosPagos: DatosPagosComponent;
    public modal: boolean;
    public venta_id: String;
    public tipocomprobante_id: String;
    public guia_remision: boolean;
    public uploadfile_api: String;
    public is_venta: boolean;
    public correo_invalid:Boolean;
    public lote : any;
    public parametros: Array<any>
    public iva_id : number;
    public iva_vigente:boolean;
    public iva_porcentaje : any;
    public formaspagofacturacion: Array<FormaPagoFacturacion>;
    public forma_pago_facturacion_id: String;
    public asientosContables: Array<AsientoContable>;
    public asientoContableVentas: AsientoContable;
    public parametrosContabilidad: Array<ParametroContabilidad>;
    public periodoContable: PeriodoContable;
    constructor(
        public correoService: ValidarCorreoService,
        public tipoComprobanteService: TipoComprobanteService,
        public comprobanteService: ComprobanteService,
        public fb: FormBuilder,
        public ss: SessionService,
        public bodegaService: BodegaService,
        public clienteService: ClienteService,
        private modalService: BsModalService,
        public formaPagoService: FormaPagoService,
        public ventaService: VentaService,
        public proformaService: ProformaService,
        public cajaService: CajaService,
        private parametroService: ParametroService,
        private blockService: BlockService,
        private inventarioService: InventarioService,
        public productoService: ProductoService,
        public cbtContadorService: CbtContadorService,
        public utils: UtilsService,
        public impuestoPorcentajeService: ImpuestoPorcentajeService,
        public formasPagoFacturacionService: FormasPagoFacturacionService,
        private parametroContabilidadService: ParametroContabilidadService,
        private periodoContableService: PeriodoContableService,
        //public numberFormat: NumberFormatPipe,
    ){
        this.tipos = [];
        this.venta = new Venta();
        this.vl = new Validation();
        this.validDateFecha = false;
        this.bodegas = [];
        this.cliente = new Cliente();
        this.PreciosAdd = new PrecioAdicional();
        this.ventasDetalle = [];
        this.IVA = 0;
        this.Identif = "";
        this.IVA_PARAM = 0;
        this.formasPago = [];        
        this.cambio = 0;
        this.total_pago = 0;
        this.msgSweet = new SweetMessage();
        this.bodegas_selected = [];
        this.cajas = [];
        this.caja = new Caja();
        this.isPrinted = false;
        this.isMail = false;
        this.ventaIdPrinted = "";
        this.fecha_emision = moment(this.fecha_emision);
        this.fecha_actual = moment(this.fecha_actual);
        this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
        this.numero_autorizacion = "";
        this.cobro = new Cobro();
        this.cheques = [];
        this.datos = [];
        this.tarjetas = [];
        this.transferencias = [];
        this.valorefectivo = 0;
        this.proforma = new Proforma();
        this.secuencial = 0;
        this.detalle = "";
        this.venta_detalle = new VentaDetalle();
        this.ventaElectronica = new VentaElectronica();
        this.parametrosContabilidad = [];
        this.is_numero_manual = false;
        this.is_precios = false;
        this.numero_documento = "";
        this.Mod_FactElec = this.ss.getData("mod_felectronica");
        this.Mod_Inventario = this.ss.getData("mod_inventario");
        this.Mod_Cartera = this.ss.getData("mod_cartera");
        this.Mod_Logistica = this.ss.getData("mod_logistica");
        this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
        //this.cuotas_credito = [];
        this.amortizacion = new Amortizacion();
        this.correos = [];
        this.is_precio_unitario_editable = false;
        this.ruta_imagen = "";
        this.config = new ConfigService();
        this.calculo_decimales = 2;
        this.numero_decimales = 2;
        this.format_decimal = "0,0.00";
        this.modal = false;
        this.venta_id = "";
        this.tipocomprobante_id = "";
        this.guia_remision = false;
        this.uploadfile_api = environment.uploadfile_api;
        this.is_venta = false;
        this.correo_invalid = false;
        this.lote = new Lote();
        this.parametros = [];
        this.iva_id = 0;
        this.iva_vigente = false;
        this.iva_porcentaje = 0;
        this.formaspagofacturacion = [];
        this.forma_pago_facturacion_id = "";
        this.periodoContable = new PeriodoContable();
    }

    ngOnInit(){
        //this.venta.bodega_id = this.ss.getData('bodega_id');
        
        this.is_venta = true;
        let p1 =this.getParametros(); 
        //Inicializar cajas
        let p2 = this.getCajas();
        //Inicializar comprobantes
        let p3 = this.getTiposComprobante();
        //Inicializar bodegas
        let p4 = this.getBodegas();

        let p5 = this.getParamDocumentoManual();
        let p6 = this.getPreciosAdicionales();
        let p7 = this.getPrecioUnitarioEditable();
        let p8 = this.getBodegaBySucursal();
        let p9 = this.getParamNumeroDecimales();
        let p10 = this.getIVA(129);
        let p11 = this.getFormasPagoFacturacion();
        let p12 = null;
		if( this.Mod_Cartera && this.Mod_Contabilidad ) {
			p12 = this.getParametroContabilidadVentas();
		}

        this.loading = true;

        Promise.all([p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12]).then(
            res => this.loading = false,
            err => this.loading = false
        );
    }

    getBodegaBySucursal(){
        return new Promise((resolve, reject) => {
            if( !this.Mod_Inventario ){
                this.venta.bodega_id = "1"; // BODEGA POR DEFECTO / SUCURSAL 1
                resolve(true);
            }else{
                this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                    res => {
                        this.venta.bodega_id = res.data[0].id;
                        resolve(true);
                    },
                    err => {
                        this.venta.bodega_id = "";
                        reject()
                    }
                );
            }
        });
    }

    getPeriodoActual(){
        return new Promise((resolve, reject) => {
            let qs = "?periodo=" + moment(this.venta.fecha_emision).format('YYYY');
            this.periodoContableService.getPeriodoActual(qs).subscribe(
                res => {
                    this.periodoContable = res;
                    resolve(true);
                },
                err => {
                    reject(err);
                }
            );
        });
    }

    getParametroContabilidadVentas(){
        return new Promise((resolve, reject) => {
			// let qs = "?in[id]=9,11,16,17,18,20,22&embed=cuentacontable";
			let qs = "?in[tipo]=V,P&embed=cuentacontable";
			this.parametroContabilidadService.getAll(qs).subscribe(
				res => {
					let is_confirmedParametros = true;
					this.parametrosContabilidad.forEach(parametroContabilidad => {
						if( parametroContabilidad.cuenta_contable_id == null ){
							is_confirmedParametros = false;
							return false;
						}
					});
					if(!is_confirmedParametros){
						this.msgSweet.showMessage('error-message', "Por favor, confirmar los parámetros de las cuentas contables.");
					}else{
						this.parametrosContabilidad = res.data;
					}
					resolve(true);
				},
				err => {
					reject(err);
				}
			);
            
        });
    }
    
    setValueAsientoContable(){
        
        let asientoContable = new AsientoContable();
        let asientoContableCobros = new AsientoContable();
        asientoContable.fecha_emision = this.venta.fecha_emision;
        asientoContable.tipocomprobante = this.venta.tipocomprobante;
        asientoContable.tipo_comprobante_id = this.venta.tipo_comprobante_id;
        asientoContable.periodo_contable_id = this.periodoContable.id;
        asientoContable.numero_documento = this.venta.numero_documento;
		asientoContable.descripcion = this.cliente.nombre_comercial;
		asientoContable.status = 'A';
        asientoContable.empresa_id = this.venta.empresa_id;
        asientoContable.usuario_id = this.venta.usuario_id;
        asientoContable.total = this.venta.total;
        asientoContableCobros.fecha_emision = this.venta.fecha_emision;
        asientoContableCobros.tipocomprobante = this.venta.tipocomprobante;
        asientoContableCobros.tipo_comprobante_id = this.venta.tipo_comprobante_id;
        asientoContableCobros.periodo_contable_id = this.periodoContable.id;
        asientoContableCobros.numero_documento = this.venta.numero_documento;
        asientoContableCobros.descripcion = this.cliente.nombre_comercial;
        asientoContableCobros.empresa_id = this.venta.empresa_id;
        asientoContableCobros.usuario_id = this.venta.usuario_id;
        asientoContableCobros.total = this.venta.total;
        asientoContableCobros.status =  'A';
        let valor = 0;
		let valor_cheque= 0;
		let valor_tarjetas = 0;
		let valor_transferencias = 0;
		this.cheques.forEach(c=> {
			valor_cheque += Number(c.valor);
		});
		this.tarjetas.forEach(c=> {
			valor_tarjetas += Number(c.valor);
		});
		this.transferencias.forEach(c=> {
			valor_transferencias += Number(c.valor);
		});
		let isServicios = true;
		this.venta.detalle.forEach(detalle => {
            // if(!detalle.es_servicio) isServicios = false; 
            if(detalle.tipo_producto_id == '1') isServicios = false; 
		});

        this.parametrosContabilidad.forEach(parametroContabilidad => {
            let asientoContableDetalle = new AsientoContableDetalle;
            asientoContableDetalle.empresa_id = asientoContable.empresa_id;
			asientoContableDetalle.usuario_id = asientoContable.usuario_id;
			if(!isServicios){
				if(parametroContabilidad.id == '1'){
					asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.venta.total,this.calculo_decimales):0;
					asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.venta.total,this.calculo_decimales):0;
					asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
					asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
                    // asientoContable.detalle.push(asientoContableDetalle);   
                    if(parametroContabilidad.tipo_saldo == 'H'){
						asientoContable.detalle.push(asientoContableDetalle);
						// asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						asientoContable.detalle.unshift(asientoContableDetalle);
						// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
				if( parametroContabilidad.id == "6" && this.venta.iva ) {
					asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.venta.iva,this.calculo_decimales):0;
					asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.venta.iva,this.calculo_decimales):0;
					// asientoContableDetalle.haber = this.venta.subtotal;
					asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
					asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
                    // asientoContableCobros.detalle.push(asientoContableDetalle);
                    if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
			}
			
			if(this.venta.tipo == "CO" && (parametroContabilidad.id == "10" || parametroContabilidad.id == "11" || parametroContabilidad.id == "12" || parametroContabilidad.id == "13" )){
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.venta.total,this.calculo_decimales):0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.venta.total,this.calculo_decimales):0;

				if( parametroContabilidad.id == "10" && this.valorefectivo > valor_cheque && this.valorefectivo > valor_tarjetas && this.valorefectivo > valor_transferencias ) {
                    // asientoContableCobros.detalle.unshift(asientoContableDetalle);
                    if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
				else if( parametroContabilidad.id == "11" && valor_cheque > this.valorefectivo && valor_cheque > valor_tarjetas && valor_cheque > valor_transferencias ) {	
                    // asientoContableCobros.detalle.unshift(asientoContableDetalle);
                    if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
				else if(  parametroContabilidad.id == "12" && valor_tarjetas > this.valorefectivo && valor_tarjetas > valor_cheque && valor_tarjetas > valor_transferencias ) {
                    // asientoContableCobros.detalle.unshift(asientoContableDetalle);
                    if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
				else if( parametroContabilidad.id == "13"  && valor_transferencias > this.valorefectivo && valor_transferencias > valor_tarjetas && valor_transferencias > valor_cheque ) {
                    // asientoContableCobros.detalle.unshift(asientoContableDetalle);
                    if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}else if( parametroContabilidad.id == "10" && this.valorefectivo) {
                    // asientoContableCobros.detalle.unshift(asientoContableDetalle);
                    if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
			}else if(this.venta.tipo == "CR"){
				if( parametroContabilidad.id == "3" ) {
					asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
					asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
					asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.venta.total,this.calculo_decimales):0;
					asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.venta.total,this.calculo_decimales):0;
                    // asientoContableCobros.detalle.unshift(asientoContableDetalle);
                    if(parametroContabilidad.tipo_saldo == 'H'){
						// asientoContable.detalle.push(asientoContableDetalle);
						asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						// asientoContable.detalle.unshift(asientoContableDetalle);
						asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
			}
        });
        let subtotal = 0;
        let subtotalCobro = 0;
        this.venta.detalle.forEach(compraDetalle => {
            
            
            
			if(!isServicios){
                // subtotal = this.utils.redondear(!compraDetalle.es_servicio && compraDetalle.graba_iva?compraDetalle.total:compraDetalle.subtotal,this.calculo_decimales);
                subtotal = this.utils.redondear(compraDetalle.tipo_producto_id == '1' && compraDetalle.graba_iva?compraDetalle.total:compraDetalle.subtotal,this.calculo_decimales);
				let asientoContableDetalle = new AsientoContableDetalle();
				asientoContableDetalle.empresa_id = asientoContable.empresa_id;
				asientoContableDetalle.usuario_id = asientoContable.usuario_id;
				asientoContableDetalle.cuenta_contable_id = compraDetalle.cuenta_inventario_id;
				let parametroContabilidad = this.parametrosContabilidad.filter(parametro => parametro.id == '30')[0];
				parametroContabilidad.tipo_saldo ="H";
				asientoContableDetalle.debe += parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(subtotal,this.calculo_decimales):0;
				asientoContableDetalle.haber += parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(subtotal,this.calculo_decimales):0;
				let cuenta = asientoContable.detalle.filter( asientoDetalle=> compraDetalle.cuenta_inventario_id!="0" && asientoDetalle.cuenta_contable_id == compraDetalle.cuenta_inventario_id );
				
				if( cuenta.length > 0 ) {
                    
					let indexAsientoDetalle = asientoContable.detalle.findIndex(detalle => detalle.cuenta_contable_id === cuenta[0].cuenta_contable_id);
					asientoContable.detalle[indexAsientoDetalle].cuenta_contable_id = compraDetalle.cuenta_inventario_id
					asientoContable.detalle[indexAsientoDetalle].haber +=  parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(subtotal,this.calculo_decimales):0;
					asientoContable.detalle[indexAsientoDetalle].debe +=  parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(subtotal,this.calculo_decimales):0;
					
				}else if( cuenta.length == 0 && compraDetalle.cuenta_inventario_id !="0" ) {
                    // asientoContable.detalle.push(asientoContableDetalle);
                    if(parametroContabilidad.tipo_saldo == 'H'){
						asientoContable.detalle.push(asientoContableDetalle);
						// asientoContableCobros.detalle.push(asientoContableDetalle);
					}else{
						asientoContable.detalle.unshift(asientoContableDetalle);
						// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
					}     
				}
            }
            // subtotalCobro = this.utils.redondear(compraDetalle.es_servicio && compraDetalle.graba_iva?compraDetalle.total:compraDetalle.subtotal,this.calculo_decimales);
            subtotalCobro = this.utils.redondear(compraDetalle.tipo_producto_id != '1' && compraDetalle.graba_iva?compraDetalle.total:compraDetalle.subtotal,this.calculo_decimales);

			let asientoContableDetalleCobro = new AsientoContableDetalle();
			asientoContableDetalleCobro.empresa_id = asientoContableCobros.empresa_id;
            asientoContableDetalleCobro.usuario_id = asientoContableCobros.usuario_id;
			asientoContableDetalleCobro.cuenta_contable_id = compraDetalle.cuenta_ingreso_id;
			
			let parametroContabilidadCobro = this.parametrosContabilidad.filter(parametro => parametro.id == '28')[0];
            asientoContableDetalleCobro.debe += parametroContabilidadCobro.tipo_saldo=='D'?this.utils.redondear(subtotalCobro,this.calculo_decimales):0;
            asientoContableDetalleCobro.haber += parametroContabilidadCobro.tipo_saldo=='H'?this.utils.redondear(subtotalCobro,this.calculo_decimales):0;
            let cuentaCobro = asientoContableCobros.detalle.filter( asientoDetalle=> compraDetalle.cuenta_ingreso_id!="" && asientoDetalle.cuenta_contable_id == compraDetalle.cuenta_ingreso_id );
            if( cuentaCobro.length > 0 ) {
                let indexAsientoDetalle = asientoContableCobros.detalle.findIndex(detalle => detalle.cuenta_contable_id === cuentaCobro[0].cuenta_contable_id);
                asientoContableCobros.detalle[indexAsientoDetalle].cuenta_contable_id = compraDetalle.cuenta_ingreso_id
                asientoContableCobros.detalle[indexAsientoDetalle].haber +=  parametroContabilidadCobro.tipo_saldo=='H'?this.utils.redondear(subtotalCobro,this.calculo_decimales):0;
                asientoContableCobros.detalle[indexAsientoDetalle].debe +=  parametroContabilidadCobro.tipo_saldo=='D'?this.utils.redondear(subtotalCobro,this.calculo_decimales):0;
                
            }else if( cuentaCobro.length == 0 && compraDetalle.cuenta_ingreso_id !="" ) {
                // asientoContableCobros.detalle.push(asientoContableDetalleCobro);
                if(parametroContabilidadCobro.tipo_saldo == 'H'){
                    // asientoContable.detalle.push(asientoContableDetalle);
                    asientoContableCobros.detalle.push(asientoContableDetalleCobro);
                }else{
                    // asientoContable.detalle.unshift(asientoContableDetalleCobro);
                    asientoContableCobros.detalle.unshift(asientoContableDetalleCobro);   
                }     
            }
            
		
		});
        if(!isServicios){
            this.venta.asientosContables.push(asientoContable);
        }
		this.venta.asientosContables.push(asientoContableCobros);
    }

    setValueCobro(){
        this.cobro.fecha_cobro = moment(this.fecha_emision).format("YYYY-MM-DD");
        this.cobro.detalle = [];
        this.cobro.saldo = this.venta.total;

        if( this.Mod_Cartera ){
            this.cobro.recibido = this.total_pago;
            this.cobro.cambio = this.cambio;
        }else{
            this.cobro.recibido = this.venta.total;
            this.cobro.cambio = 0;
        }

        this.cobro.empresa_id = this.ss.getData("empresa_id");
        this.cobro.sucursal_id = this.ss.getData("sucursal_id");
        this.cobro.usuario_id = this.ss.getData("usuario_id");

        if( this.Mod_Cartera ){
            if( this.valorefectivo > 0 ){
                let cobro_detalle = new CobroDetalle();
                cobro_detalle.valor = this.valorefectivo;
                cobro_detalle.forma_pago_id = "1"; // EFECTIVO
                cobro_detalle.debito_credito = "D";
                cobro_detalle.empresa_id = this.ss.getData("empresa_id");
                cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
                cobro_detalle.usuario_id = this.ss.getData("usuario_id");
                this.cobro.detalle.push(cobro_detalle);
            }
    
            this.cheques.forEach(ch => {
                let cobro_detalle = new CobroDetalle();
    
                cobro_detalle.fecha_cheque = ch.fecha;
                cobro_detalle.numero_cta = ch.cuenta;
                cobro_detalle.numero_cheque = ch.numero;
                cobro_detalle.banco_id = ch.banco_id;
                cobro_detalle.observacion = ch.observacion;
                cobro_detalle.debito_credito = "D";
                cobro_detalle.valor = ch.valor;
                cobro_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
                cobro_detalle.empresa_id = this.ss.getData("empresa_id");
                cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
                cobro_detalle.usuario_id = this.ss.getData("usuario_id");
                this.cobro.detalle.push(cobro_detalle);
            });
    
            this.tarjetas.forEach(tr => {
                let cobro_detalle = new CobroDetalle();
    
                cobro_detalle.debito_credito = tr.debito_credito;
                cobro_detalle.observacion = tr.observacion;
                cobro_detalle.tipo_tarjeta_id = tr.tipo_id;
                cobro_detalle.valor = tr.valor;
                cobro_detalle.plazo = tr.plazo;
                cobro_detalle.tiempo = tr.tiempo;
                cobro_detalle.debito_credito = "D";
                cobro_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
                cobro_detalle.empresa_id = this.ss.getData("empresa_id");
                cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
                cobro_detalle.usuario_id = this.ss.getData("usuario_id");
                this.cobro.detalle.push(cobro_detalle);
            });

            this.transferencias.forEach(tr => {
                let cobro_detalle = new CobroDetalle();
    
                cobro_detalle.fecha_transferencia = tr.fecha;
                cobro_detalle.numero_cta = tr.cuenta;
                cobro_detalle.numero_comprobante = tr.numero;
                cobro_detalle.banco_id = tr.banco_id;
                cobro_detalle.observacion = tr.observacion;
    
                cobro_detalle.valor = tr.valor;
                cobro_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
                cobro_detalle.empresa_id = this.ss.getData("empresa_id");
                cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
                cobro_detalle.usuario_id = this.ss.getData("usuario_id");
                this.cobro.detalle.push(cobro_detalle);
            });
        }else{
            let cobro_detalle = new CobroDetalle();
            cobro_detalle.valor = this.venta.total;
            cobro_detalle.forma_pago_id = "1"; // EFECTIVO
            cobro_detalle.debito_credito = "D";
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        }

       
    }

    

    setValueEntity(){
        this.venta.is_secuencial_manual = this.is_numero_manual;
        if( this.is_numero_manual ) this.venta.numero_documento = this.numero_documento;
        this.venta.cliente_id = this.cliente.id;
        this.venta.cliente = this.cliente;
        this.venta.caja_id = this.caja.id;
        this.venta.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD");

        this.venta.usuario_id = this.ss.getData('usuario_id');
        this.venta.empresa_id = this.ss.getData('empresa_id');
        this.venta.sucursal_id = this.ss.getData('sucursal_id');
        this.venta.cobros.push(this.cobro);

        if( !this.Mod_Cartera ){
            this.venta.tipo = "CO";
        }

        this.ventasDetalle.forEach(detalle => {
            if( parseInt(this.venta.tipo_comprobante_id.toString()) === 1 || parseInt(this.venta.tipo_comprobante_id.toString()) === 4 ){
                if( !detalle.graba_iva ){
                    detalle.iva = 0;
                }else{
                    detalle.iva = detalle.subtotal * this.IVA;
                }
            }else{
                detalle.iva = 0;
            }
            if( detalle.desc_porcent > 0  ){
                let total = this.utils.redondear((detalle.precio_unitario * detalle.cantidad),this.calculo_decimales);
                let desc_valor = total * (detalle.desc_porcent / 100);
                //detalle.desc_valor = Math.round(desc_valor * 100) / 100;
                detalle.desc_valor = this.utils.redondear(desc_valor,this.calculo_decimales);
            }
            detalle.total = detalle.subtotal + detalle.iva;
        });

        this.venta.detalle = this.ventasDetalle;

        this.amortizacion.valor = this.saldoCuotas();
        this.amortizacion.numero_cuotas = this.amortizacion.detalle.length;
        this.amortizacion.empresa_id = this.ss.getData('empresa_id');
        this.amortizacion.usuario_id = this.ss.getData('usuario_id');
        this.venta.amortizacion = this.amortizacion;

        
        
        
    }

    setVentaElectronica(venta: Venta){
        let ventaElectronica = {};
        ventaElectronica['datos'] = {};
        ventaElectronica['datos']['infoTributaria'] = {};
        ventaElectronica['datos']['infoTributaria']['ambiente'] = "";
        ventaElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
        ventaElectronica['datos']['infoTributaria']['razonSocial'] = "";
        ventaElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');
        ventaElectronica['datos']['infoTributaria']['claveAcceso'] = "";
        ventaElectronica['datos']['infoTributaria']['codDoc'] = "01"; //Factura
        ventaElectronica['datos']['infoTributaria']['estab'] = venta.serie;
        ventaElectronica['datos']['infoTributaria']['ptoEmi'] = venta.punto_emision;
        ventaElectronica['datos']['infoTributaria']['secuencial'] = venta.secuencial.toString().padStart(9,"0");
        ventaElectronica['datos']['infoTributaria']['dirMatriz'] = ""; //this.ss.getData('emp_direccion');

        ventaElectronica['datos']['infoFactura'] = {};
        ventaElectronica['datos']['infoFactura']['fechaEmision'] =  moment(venta.fecha_emision).format("DD/MM/YYYY");
        ventaElectronica['datos']['infoFactura']['dirEstablecimiento'] = this.ss.getData('sucursal_direccion');
        ventaElectronica['datos']['infoFactura']['tipoIdentificacionComprador'] = this.cliente.tipoidentificacion.cod_dni;
        ventaElectronica['datos']['infoFactura']['razonSocialComprador'] = this.cliente.razon_social.toString().replace("&","Y");
        ventaElectronica['datos']['infoFactura']['identificacionComprador'] = this.cliente.dni;

        let totalSinImpuestos = 0;
        let totalDescuento = 0;
        this.venta.detalle.forEach(item => {
            //totalSinImpuestos += Math.round(item.subtotal * 100) / 100;
            totalSinImpuestos += this.utils.redondear(item.subtotal,this.calculo_decimales);
            totalDescuento += this.utils.redondear(item.desc_valor,this.calculo_decimales);
        });

        ventaElectronica['datos']['infoFactura']['totalSinImpuestos'] = totalSinImpuestos;
        ventaElectronica['datos']['infoFactura']['totalDescuento'] = totalDescuento;

        ventaElectronica['datos']['infoFactura']['totalConImpuestos'] = [];
        if(venta.subtotal_iva0 > 0){
            let totalConImpuestos = {};
            totalConImpuestos['codigo'] = 2;
            totalConImpuestos['codigoPorcentaje'] = 0;
            //totalConImpuestos['descuentoAdicional'] = (Math.round(venta.desct_valor * 100) / 100);
            totalConImpuestos['descuentoAdicional'] = this.utils.redondear(venta.desct_valor, this.calculo_decimales);
            //totalConImpuestos['baseImponible'] = (Math.round(venta.subtotal_iva0 * 100) / 100);
            totalConImpuestos['baseImponible'] = this.utils.redondear(venta.subtotal_iva0, this.calculo_decimales);
            totalConImpuestos['valor'] = "0.00";

            ventaElectronica['datos']['infoFactura']['totalConImpuestos'].push(totalConImpuestos);
        }

        if(venta.subtotal_iva12 > 0){
            let totalConImpuestos = {};
            totalConImpuestos['codigo'] = 2;
            totalConImpuestos['codigoPorcentaje'] = 2;
            //totalConImpuestos['descuentoAdicional'] = (Math.round(venta.desct_valor * 100) / 100);
            totalConImpuestos['descuentoAdicional'] = this.utils.redondear(venta.desct_valor, this.calculo_decimales);
            //totalConImpuestos['baseImponible'] = (Math.round(venta.subtotal_iva12 * 100) / 100);
            totalConImpuestos['baseImponible'] = this.utils.redondear(venta.subtotal_iva12, this.calculo_decimales);
            //totalConImpuestos['valor'] = (Math.round(venta.iva * 100) / 100);
            totalConImpuestos['valor'] = this.utils.redondear(venta.iva, this.calculo_decimales);

            ventaElectronica['datos']['infoFactura']['totalConImpuestos'].push(totalConImpuestos);
        }

        ventaElectronica['datos']['infoFactura']['propina'] = "0.00";
        //ventaElectronica['datos']['infoFactura']['importeTotal'] = (Math.round(venta.total * 100) / 100);
        ventaElectronica['datos']['infoFactura']['importeTotal'] = this.utils.redondear(venta.total, this.calculo_decimales);
        ventaElectronica['datos']['infoFactura']['moneda'] = "DOLAR";

        ventaElectronica['datos']['infoFactura']['pagos'] = [];

        if( this.Mod_Cartera ){
            if( this.venta.tipo == "CO" ){
                //01 => EFECTIVO
                //this.valorefectivo = Math.round(this.valorefectivo * 100) / 100;
                this.valorefectivo = this.utils.redondear(this.valorefectivo, this.calculo_decimales);
                if( this.valorefectivo > 0 ){
                    let pago = {};
                    pago["formaPago"] = "01";
                    //pago["total"] = (Math.round((parseFloat(this.valorefectivo.toString()) - parseFloat(this.cambio.toString())) * 100) / 100);
                    pago["total"] = this.utils.redondear((parseFloat(this.valorefectivo.toString()) - parseFloat(this.cambio.toString())), this.calculo_decimales);
                    pago["plazo"] = "0";
                    pago["unidadTiempo"] = "DIAS";
                    ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
                }
    
                let totalChOtrosCon = 0;
                this.cheques.forEach(ch => {
                    totalChOtrosCon += parseFloat(ch.valor.toString());
                });
    
                //20 => OTROS
                //totalChOtrosCon = Math.round(totalChOtrosCon * 100) / 100;;
                totalChOtrosCon = this.utils.redondear(totalChOtrosCon, this.calculo_decimales);
                if( totalChOtrosCon > 0 ){
                    let pago = {};
                    pago["formaPago"] = "20";
                    //pago["total"] = (Math.round(totalChOtrosCon * 100) / 100);
                    pago["total"] = this.utils.redondear(totalChOtrosCon, this.calculo_decimales);
                    pago["plazo"] = "0";
                    pago["unidadTiempo"] = "DIAS";
                    ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
                }
    
                //16 => DEBITO; 19 => CREDITO
                this.tarjetas.forEach(tr => {
                    let pago = {};
                    pago["formaPago"] = (tr.debito_credito==="D"?"16":"19");
                    //tr.valor = Math.round(tr.valor * 100) / 100;;
                    tr.valor = this.utils.redondear(tr.valor, this.calculo_decimales);
                    //pago["total"] = (Math.round(tr.valor * 100) / 100);
                    pago["total"] = this.utils.redondear(tr.valor, this.calculo_decimales);
                    pago["plazo"] = tr.plazo;
                    pago["unidadTiempo"] = tr.tiempo.toUpperCase();
                    ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
                });
            }else{
                //20 => OTROS
                let pago = {};
                pago["formaPago"] = "20";
                let valor = parseFloat(venta.total.toString()) - parseFloat(this.cambio.toString())
                //valor = Math.round(valor * 100) / 100;
                //pago["total"] = (Math.round(valor * 100) / 100);
                pago["total"] = this.utils.redondear(valor, this.calculo_decimales);
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
            }
            let totalTrOtrosCon =0;
            this.transferencias.forEach(tr => {
                totalTrOtrosCon += parseFloat(tr.valor.toString());
            });

            if( totalTrOtrosCon > 0 ){
                let pago = {};
                pago["formaPago"] = "20";
                //pago["total"] = (Math.round(totalChOtrosCon * 100) / 100);
                pago["total"] = this.utils.redondear(totalTrOtrosCon, this.calculo_decimales);
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
            }
           
        }else{
            let pago = {};
            let forma_pago_fact: FormaPagoFacturacion = this.formaspagofacturacion.find(item => item.id == this.forma_pago_facturacion_id);
            pago["formaPago"] = forma_pago_fact.cod_pago;
            pago["total"] = this.utils.redondear(this.venta.total, this.calculo_decimales);
            pago["plazo"] = "0";
            pago["unidadTiempo"] = "DIAS";
            ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
        }

        ventaElectronica['datos']['detalles'] = [];
        venta.detalle.forEach((item) => {
            let detalle = {};
            let detalle_item = item.detalle.toString().replace(/\n/g,", ");

            detalle['codigoPrincipal'] = (item.codigo).replace(/\//g,'-');
            detalle['codigoAuxiliar'] = (item.codigo).replace(/\//g,'-');
            detalle['descripcion']  = (item.producto + (item.detalle.length>0?" - " + detalle_item:"")).replace(/\//g,'-');
            detalle['cantidad'] = item.cantidad;
            //detalle['precioUnitario'] = (Math.round(item.precio_unitario * 100) / 100);
            //detalle['precioUnitario'] = this.utils.redondear(item.precio_unitario, this.calculo_decimales);
            detalle['precioUnitario'] = item.precio_unitario;
            //detalle['descuento'] = (Math.round(item.desc_valor * 100) / 100);
            detalle['descuento'] = this.utils.redondear(item.desc_valor, this.calculo_decimales);
            //detalle['precioTotalSinImpuesto'] = (Math.round(item.subtotal * 100) / 100);
            detalle['precioTotalSinImpuesto'] = this.utils.redondear(item.subtotal, this.calculo_decimales);
            detalle['impuestos'] = [];
            let impuesto = {};
            impuesto['codigo'] = 2;
            impuesto['codigoPorcentaje'] = (item.iva > 0 ? 2 : 0 );
            impuesto['tarifa'] = (item.iva  > 0 ? 12 : 0 );
            //impuesto['baseImponible'] = (Math.round(item.subtotal * 100) / 100);
            impuesto['baseImponible'] = this.utils.redondear(item.subtotal, this.calculo_decimales);
            //impuesto['valor'] = Math.round(item.iva * 100) / 100;
            impuesto['valor'] = this.utils.redondear(item.iva, this.calculo_decimales);
            detalle['impuestos'].push(impuesto);
            ventaElectronica['datos']['detalles'].push(detalle);
        });
        
        ventaElectronica['datos']['infoAdicional'] = [];
        let adicional = {};
        adicional['Email'] = this.correos.toString(); //this.cliente.correo;
        adicional['Direccion'] = this.cliente.direccion.replace(/\//g,'-');

        let telefono = "0999999999";
        if( this.cliente.telefono.toString().trim().length > 0 ){
            telefono = this.cliente.telefono.toString();
        }
        if( this.cliente.celular.toString().trim().length > 0 ){
            telefono = this.cliente.celular.toString();
        }
        adicional['Telefono'] = telefono;

        this.datos.forEach(dato => {
            adicional[dato.descripcion.toString()] = dato.valor.toString();
        });

        ventaElectronica['datos']['infoAdicional'].push(adicional);

        return ventaElectronica;
    }

    openEmitirGuiaRemisionVentaModal(){
        this.modal = true;
        const initialState = {venta_id: this.venta_id, modal: this.modal};
        this.bsModalRef = this.modalService.show(EmitirGuiaremisionVentaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
        this.bsModalRef.content.cerrarModal.take(1).subscribe((value)=>{
            if(value.isSaved){
                this.guia_remision = false;
            }
        });
    }

    onSubmit() {
        let preg = "¿Está seguro de confirmar la venta?";
        const initialState = { Pregunta: preg, Respuesta:false };
        this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
        
        this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
            if(Respuesta == true){
                
                this.setValueCobro();
                this.setValueEntity();

                if( this.Mod_FactElec ){
                    if( this.venta.cliente.es_contribuyente ){
                        if( this.venta.cliente.num_contribuyente.toString().trim().length === 0 ){
                            this.msgSweet.showMessage('error-message', "El cliente no consta con número de contribuyente");
                            return false;
                        }
                    }
                    if(this.venta.total >= 200 && this.venta.cliente.id == "1" && this.venta.tipo_comprobante_id == "4"){
                        this.msgSweet.showMessage('error-message', "No puede realizar una venta cuyo monto supere los $200 a Consumidor Final");
                        return false;
                    }

                    this.venta.json_string = this.setVentaElectronica(this.venta);
                }
                let now = moment();
                let fecha_actual = moment(now.format(), moment.ISO_8601).format("YYYY-MM-DD");
                if( this.venta.fecha_emision > fecha_actual ){
                    this.msgSweet.showMessage('error-message', "La fecha seleccionada es superior a la fecha actual");
                    return false;
                }

                this.cliente.correo = this.correos.toString();
                this.loading = true;
                if( this.Mod_Cartera && this.Mod_Contabilidad ){

                    this.getPeriodoActual().then(
                        res => {
                            this.setValueAsientoContable();
                            this.saveVenta();   
                        }
                    );
                }else {
                    this.saveVenta();   
                }
            }
        });
    }


    saveVenta() {
        let qs = this.Mod_Contabilidad ? '?asiento=true' : '';
        this.ventaService.save(this.venta,qs).subscribe(
            res => {
                this.loading = false;
                this.venta_id = res.id;
                this.tipocomprobante_id = res.tipo_comprobante_id;
                this.guia_remision = true;
                if( this.Mod_FactElec ){
                    this.cbtContadorService.actualizarContador();
                }
                
                this.isPrinted = true;
                this.isMail = true;
                this.ventaIdPrinted = res.id;

                this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente - CAMBIO: ' + numeral(this.cambio).format("0,0.00"));
                let bodega_id = this.venta.bodega_id;
                this.venta = new Venta();
                this.venta.bodega_id = bodega_id;
                this.cliente = new Cliente();
                this.amortizacion = new Amortizacion();
                this.ventasDetalle = [];
                this.correos = [];
                this.cambio = 0;
                this.total_pago = 0;
                this.datos = [];

                this.cheques = [];
                this.tarjetas = [];
                this.transferencias = [];
                this.valorefectivo = 0;

                this.datosPagos.total_cheque = 0;
                this.datosPagos.total_tarjeta = 0;
                this.datosPagos.total_transferencia = 0;
                this.datosPagos.total_efectivo = 0;
                this.forma_pago_facturacion_id = "";

                this.numero_documento = "";
            },
            err => {
                this.loading = false;
                this.venta.asientosContables = [];
                this.msgSweet.showMessage('error-message',err);
            }
        );

    }

    getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
					this.IVA = parseFloat(this.iva_porcentaje) / 100;
					this.IVA_PARAM = this.iva_porcentaje;
                    this.calcularFactura();
                    this.calcularCuotasCredito();
					resolve(true);
				},
				err => {
					this.iva_porcentaje = 0;
                    this.IVA = 0;
                    this.IVA_PARAM = 0 ;
					reject(err);
				}
			);

			
		});
	}

    getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve(true);
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

    getCajas(){
        return new Promise((resolve, reject ) => {
            this.cajaService.getAll("?embed=sucursal&sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                res => {                
                    this.cajas = res.data;
                    resolve(true);
                },
                err => {                
                    this.cajas = [];
                    reject(err);
                }
            );
        });        
    }

    onChangeCaja(){
        if( this.venta.tipo_comprobante_id ){
            this.getNumeroComprobante();
        }
    }

    getTiposComprobante(){
        return new Promise((resolve, reject)=>{
            
            if(this.Mod_FactElec){
                this.Identif = "4,2";
            }
            else{
                this.Identif = "1,2";
            }

            this.tipoComprobanteService.getAll("?in[id]=" + this.Identif + "&sort=nombre").subscribe(
                res => {
                    if( res.data.length ){
                        this.tipos = res.data;
                    }else{
                        this.tipos = [];
                    }
                    resolve(true);
                },
                err => {
                    this.tipos = [];
                    reject(err);
                }
            );
        });
    }

    getBodegas(){
        return new Promise((resolve, reject)=>{
            this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                res => {
                    if (!res.data.length) {
                        this.bodegas = [];
                    } else {
                        this.bodegas = res.data;
                        this.bodegas_selected.push(this.bodegas[0].id);
                    }
                    resolve(true);
                },
                err => {
                    this.bodegas = [];
                    reject(err);
                }
            );
        });		
    }
    
    getParamDocumentoManual(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let documento_manual_id = 9;
            this.parametroService.getById(documento_manual_id).subscribe(
                res => {
                    this.is_numero_manual = (res.valor.toString().trim() === "SI");
                    resolve(true);
                },
                err => {
                    this.is_numero_manual = false;
                    reject(err);
                }
            );
        });
    }

    getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.datosPagos.numero_decimales = this.numero_decimales;
                    this.datosPagos.setFormat();

                    this.format_decimal = "0,0." + digitos
                    resolve(true);
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    getFormasPagoFacturacion(){
        return new Promise((resolve, reject) => {
            this.formasPagoFacturacionService.getAll().subscribe(
                res => {
                    this.formaspagofacturacion = res.data;
                    resolve(true);
                },
                err => {
                    this.formaspagofacturacion = [];
                    reject();
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
    }

    getPreciosAdicionales(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_adicional_id = 16;
            this.parametroService.getById(precio_adicional_id).subscribe(
                res => {
                    this.is_precios = (res.valor.toString().trim() === "SI");
                    resolve(true);
                },
                err => {
                    this.is_precios = false;
                    reject(err);
                }
            );
        });
    }

    getPrecioUnitarioEditable(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_unitario_editable_id = 18;
            this.parametroService.getById(precio_unitario_editable_id).subscribe(
                res => {
                    this.is_precio_unitario_editable = (res.valor.toString().trim() === "1");
                    resolve(true);
                },
                err => {
                    this.is_precio_unitario_editable = false;
                    reject(err);
                }
            );
        });
    }

    // getIfUsoLote(){
    //     return new Promise((resolve, reject) => {
    //         let if_uso_lote = 20;
    //         this.parametroService.getById(if_uso_lote).subscribe(
    //             res => {
    //                 this.if_uso_lote = (res.valor.toString().trim() === "1");
    //                 resolve();
    //             },
    //             err => {
    //                 this.if_uso_lote = false;
    //                 reject(err);
    //             }
    //         );
    //     });
    // }
    
    onChangeComprobante(){
        this.isPrinted = false;
        this.guia_remision = false;
        this.isMail = false;
        this.ventaIdPrinted = "";
        this.getNumeroComprobante();
    }
   
    getNumeroComprobante(){
        if( !this.venta.tipo_comprobante_id ){
            this.venta.serie = "";
            this.venta.punto_emision = "";
            this.venta.secuencial = "";
            this.venta.numero_documento = "";
            return;
        }

        if( !this.caja.id ){
            this.venta.numero_documento = "";
            this.msgSweet.showMessage('error-message', "Seleccione la caja");
            return;
        }

        let caja = this.cajas.filter(x => x.id == this.caja.id)[0];

        // this.loading = true;
        
        this.comprobanteService.getSecuencial(this.venta.tipo_comprobante_id, caja.id).subscribe(
            res => {
                // this.loading = false;
                if(res.secuencial){
                    this.venta.serie = caja.sucursal.establecimiento;
                    this.venta.punto_emision = caja.punto_emision;
                    this.venta.secuencial = res.secuencial;

                    this.venta.numero_documento = this.venta.serie + "-" + this.venta.punto_emision + "-" + this.venta.secuencial;
                }else{
                    this.venta.serie = "";
                    this.venta.punto_emision = "";
                    this.venta.secuencial = "";
                    this.venta.numero_documento = "";
                }
                this.calcularFactura();
                this.calcularCuotasCredito();
            },
            err => {
                this.loading = false;
                this.venta.serie = "";
                this.venta.punto_emision = "";
                this.venta.secuencial = "";
                this.venta.numero_documento = "";
                
                this.msgSweet.showMessage('error-message', err);
            }
        );
    }

    onChangeBodega(event, bodega_id) {
        this.bodegas_selected.push(bodega_id);

        if (this.ventasDetalle.length > 0) {
            this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de cambiar de bodega? El detalle de la compra se perderá").then(
                res => {
                    if (res == "ok") {
                        this.ventasDetalle = [];
                    }else{
                        this.venta.bodega_id = this.bodegas_selected[this.bodegas_selected.length - 2];
                        this.bodegas_selected.push(this.venta.bodega_id);
                    }
                },
                err => {
                    this.venta.bodega_id = this.bodegas_selected[this.bodegas_selected.length - 2];
                    this.bodegas_selected.push(this.venta.bodega_id);
                }
            );
        }else{
            this.ventasDetalle = [];
        }
	}

    onValidDateFecha(){
        return this.validDateFecha = this.vl.validDate(this.fecha_emision.toString());
    }

    onSearchCliente(event) {
        if( event.keyCode === 13 ){
			if( this.cliente.dni.toString().trim().length == 0 ){
				this.cliente = new Cliente();
				return;
			}else{
				this.clienteService.getByDni(this.cliente.dni).subscribe(
					res => {
						this.loading = false;
						if (res.length > 0) {
							this.cliente = res[0];
						}else{
							this.cliente = new Cliente();
							this.openDialogCliente();
						}
					},
					err => {
						this.loading = false;
						this.openDialogCliente();
					}
				);
			}
        }
    }
    
    openDialogCliente() {
        this.correos = [];
		const initialState = {qs: "&embed=tipoidentificacion"};
		this.bsModalRef = this.modalService.show(ClienteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

        this.bsModalRef.content.sendCliente.take(1).subscribe((cliente) => {
            this.cliente = cliente;

            if( this.cliente.correo.trim().length ){
                this.correos = this.cliente.correo.split(',');
            }
        });
    }

    onSearchServicio(){
        if( !this.venta.tipo_comprobante_id ){
            this.msgSweet.showMessage('error-message', "Seleccione el tipo de comprobante");
            return;
        }

        const initialState = {numero_decimales: this.numero_decimales, es_vendido: 1};
		this.bsModalRef = this.modalService.show(ServicioModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
			this.sendObjectProducto(value);
		});
    }
    
    onSearchProducto() {
        if( !this.venta.tipo_comprobante_id ){
            this.msgSweet.showMessage('error-message', "Seleccione el tipo de comprobante");
            return;
        }

        if( !this.venta.bodega_id ){
            this.msgSweet.showMessage('error-message', "Seleccione la bodega");
            return;
        }
        
		const initialState = {bodega_id: this.venta.bodega_id, numero_decimales: this.numero_decimales, es_vendido: 1, tipo_producto_id: '1' };
		this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
			this.sendObjectProducto(value)
		});
    }

    onSearchConsumible() {

		const initialState = { bodega_id: this.venta.bodega_id, numero_decimales: this.numero_decimales, es_vendido: 1, tipo_producto_id: '3' };
		this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {

			// value.precio = 0;
			let incluye_precio = false;
			// this.impuesto_id= value.impuesto_iva_id;
			this.sendObjectProducto(value);
			// if (this.impuesto_id != 0) {
			// 	this.getImpuestoPorcentaje(this.impuesto_id);
			// }
		});


	}

    onSearchProforma(){
        if( !this.venta.tipo_comprobante_id ){
            this.msgSweet.showMessage('error-message', "Seleccione el tipo de comprobante");
            return;
        }

        const initialState = {numero_decimales: this.numero_decimales};
		this.bsModalRef = this.modalService.show(ProformaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProforma.take(1).subscribe((value) => {            
			this.getProforma(value.id);
		});
    }

    onSearchLote(ventaDetalle :any) {
        const initialState = {producto_id:ventaDetalle.producto_id ,numero_decimales: this.numero_decimales};
        this.bsModalRef = this.modalService.show(LoteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
        this.bsModalRef.content.sendLote.take(1).subscribe((value) => {
            ventaDetalle.lote = value;
            ventaDetalle.lote_id = value.id;
            
            if (ventaDetalle.lote != null) {
                
                if( ventaDetalle.lote.cantidad < ventaDetalle.cantidad ){
                    this.msgSweet.showMessage('error-message', "La cantidad del producto es mayor que la cantidad del lote");
                    return;
                }
            }
        
        });
        
      
        
    }

    openModalSerie(venta_detalle: VentaDetalle) {
		const initialState = { series: venta_detalle.series, numero_decimales: this.numero_decimales, bodega_id: this.venta.bodega_id, producto_id:venta_detalle.producto_id };
		this.bsModalRef = this.modalService.show(SerieEgresoModalComponent, Object.assign({backdrop: 'static',initialState }));
		this.bsModalRef.content.sendSeries.take(1).subscribe((value) => {
			venta_detalle.series = value;
			
            venta_detalle.cantidad = venta_detalle.series.length;

            let valor = this.utils.redondear((venta_detalle.cantidad * venta_detalle.precio_unitario), this.calculo_decimales);
            let subtotal = valor - venta_detalle.desc_valor;
            let porcent_value = subtotal * (venta_detalle.desc_porcent / 100)
            venta_detalle.subtotal = subtotal - porcent_value;

            this.calcularFactura();
			this.calcularCuotasCredito();
		});
	}
    
    sendObjectProducto(producto: any) {
        let temp = this.ventasDetalle.find(x => x.producto_id == producto.id);
        
		//if (!temp) {
			let venta_detalle = new VentaDetalle();
            venta_detalle.cantidad_stock = producto.cantidad_stock;
            venta_detalle.cantidad = (producto.cantidad?producto.cantidad:1);
            // venta_detalle.es_servicio = producto.es_servicio;
            venta_detalle.tipo_producto_id = producto.tipo_producto_id;
            venta_detalle.if_uso_lote = producto.if_uso_lote;
            venta_detalle.descripcion = producto.descripcion;
            venta_detalle.producto = producto.nombre;
            venta_detalle.codigo = producto.codigo;
            venta_detalle.unidad = producto.unidad;
            venta_detalle.imagen = producto.imagen;
            venta_detalle.producto_id = producto.id;
            venta_detalle.graba_iva = producto.graba_iva;
            venta_detalle.precio_unitario = parseFloat(producto.precio);
            venta_detalle.cuenta_inventario_id = producto.cuenta_inventario_id;
            venta_detalle.cuenta_ingreso_id = producto.cuenta_ingreso_id;
            venta_detalle.cuenta_costo_gasto_id = producto.cuenta_costo_gasto_id;
            //venta_detalle.subtotal = venta_detalle.cantidad * venta_detalle.precio_unitario;
            venta_detalle.subtotal = this.utils.redondear((venta_detalle.cantidad * venta_detalle.precio_unitario), this.calculo_decimales);

            if( parseInt(this.venta.tipo_comprobante_id.toString()) === 1 || parseInt(this.venta.tipo_comprobante_id.toString()) === 4 ){
                if( producto.graba_iva === 0 ){
                    venta_detalle.iva = 0;
                    venta_detalle.porct_iva = 0;
                }else{
                    venta_detalle.iva = venta_detalle.subtotal * this.IVA;
                    venta_detalle.porct_iva = this.IVA_PARAM;
                }
            }else{
                venta_detalle.iva = 0;
                venta_detalle.porct_iva = 0;
            }

			venta_detalle.total = venta_detalle.subtotal + venta_detalle.iva;
			venta_detalle.usuario_id = this.ss.getData('usuario_id');
			venta_detalle.empresa_id = this.ss.getData('empresa_id');
			venta_detalle.sucursal_id = this.ss.getData('sucursal_id');

            this.ventasDetalle.push(venta_detalle);
            this.calcularFactura();
            this.calcularCuotasCredito();
		//}

    }

    changeValue(event, venta_detalle: VentaDetalle, campo: string){
        let dscto_valor = venta_detalle.desc_valor;
        let dscto_porcent = venta_detalle.desc_porcent;
        let value = event.target.value;

        venta_detalle[campo] = value;

        if( campo === 'desc_porcent' ){
            if( venta_detalle[campo] > 100 ){
                venta_detalle[campo] = 100;
            }
        }

        let valor = this.utils.redondear((venta_detalle.cantidad * venta_detalle.precio_unitario), this.calculo_decimales);
        let subtotal = valor - venta_detalle.desc_valor;
        let porcent_value = subtotal * (venta_detalle.desc_porcent / 100)
        venta_detalle.subtotal = subtotal - porcent_value;

        this.calcularFactura();
        this.calcularCuotasCredito();
    }

    verificationValue(event, venta_detalle: VentaDetalle, campo: string){
        if( event.target.value.trim().length === 0 ){
            if( campo === 'cantidad' ){
                venta_detalle[campo] = 1;
            }else{
                venta_detalle[campo] = 0;
            }
        }
    }

    calcularFactura() {
        this.venta.subtotal_iva12 = 0;
        this.venta.subtotal_iva0 = 0;
        this.venta.subt_desct_iva12 = 0;
        this.venta.subt_desct_iva0 = 0;
        this.venta.subt_desct_iva0 = 0;
        this.venta.subt_desct_iva12 = 0;
        this.venta.iva = 0;
        this.venta.total = 0;
        let tipo_comprobante_id = parseInt(this.venta.tipo_comprobante_id.toString());

        this.ventasDetalle.forEach(obj => {
			if( (tipo_comprobante_id === 1 && obj.graba_iva) || tipo_comprobante_id === 4 && obj.graba_iva ){
                this.venta.subtotal_iva12 += obj.subtotal;
            }else{
                this.venta.subtotal_iva0 += obj.subtotal;
            }
        });
        let desc_porcent = (this.venta.desct_porcent / 100);
        //desc_porcent = Math.round(desc_porcent * 100) / 100;
        desc_porcent = this.utils.redondear(desc_porcent, this.calculo_decimales);
        this.venta.desct_valor = (this.venta.subtotal_iva0 + this.venta.subtotal_iva12) * desc_porcent;
        this.venta.subt_desct_iva0 = this.venta.subtotal_iva0 - (desc_porcent * this.venta.subtotal_iva0);
        this.venta.subt_desct_iva12 = this.venta.subtotal_iva12 - (desc_porcent * this.venta.subtotal_iva12);

        if( tipo_comprobante_id === 1 || tipo_comprobante_id === 4 ){
            //this.venta.iva = Math.round((this.venta.subt_desct_iva12 * this.IVA) * 100) / 100;
            this.venta.iva = this.utils.redondear((this.venta.subt_desct_iva12 * this.IVA), this.calculo_decimales);
        }else{
            //this.venta.iva = Math.round(this.venta.subt_desct_iva12 * 100) / 100;
            this.venta.iva = this.utils.redondear(this.venta.subt_desct_iva12, this.calculo_decimales);
        }
        this.venta.total = this.venta.subt_desct_iva12 + this.venta.subt_desct_iva0 + this.venta.iva;
        this.venta.total = this.utils.redondear(this.venta.total, this.calculo_decimales);
        this.cambio = ((this.total_pago > this.venta.total)?(this.total_pago - this.venta.total):0);
        this.cambio = this.utils.redondear(this.cambio, this.calculo_decimales);
    }

    onChangeDescto(event){
        let descto = event.target.value;
    }

    onDelete(i) {
        this.ventasDetalle.splice(i, 1);
        this.calcularFactura();
        this.calcularCuotasCredito();
	}
    
    isValidForm(){
        if( this.is_numero_manual ){
            if( this.numero_documento.trim().length === 0 ){
                return false;
            }else{
                if( parseFloat(this.numero_documento.trim()) < 1 ){
                    return false;
                }
            }
        }
        if( !this.venta.tipo_comprobante_id ){
            return false;
        }
        if( !this.venta.numero_documento ){
            return false;
        }
        if( !this.vl.validDate(this.fecha_emision.toString()) ){
            return false;
        }
        if( this.Mod_Inventario ){
            if( !this.venta.bodega_id ){
                return false;
            }
        }
        if( !this.cliente.id ){
            return false;
        }else{
            if( !this.cliente.dni ){
                return false;
            }
        }
        if( !this.ventasDetalle.length ){
            return false;
        }
        if( !this.venta.tipo ){
            return false;
        }
        if( this.venta.tipo === "CO" ){
            if( this.Mod_Cartera ){
                if( this.total_pago < this.venta.total ){
                    return false;
                }
            }else{
                if( !this.forma_pago_facturacion_id){
                    return false;
                }
            }
        }
        if( this.Mod_FactElec ){
            if( this.correos.length === 0 ){
                return false;
            }
            if( this.cliente.direccion.trim().length === 0 ){
                return false;
            }

            if(this.fecha_emision < this.fecha_MesAnt){
                return false;
            }
        }
      
        /*if( !this.correos.length ){
			return false;
        }*/
        if (this.correo_invalid) {
            return false;
        }
        let b = false;
		this.ventasDetalle.forEach(item => {
			if (item.cantidad < 1 || item.precio_unitario == 0 ) {
				b = true;
			}
		});
		if (b) {
			return false;
        }
        return true;
    }



    imprimirCotizacion(){
        let params = [];        
        params["empresa_id"] = this.ss.getData('empresa_id');
        params["usuario_id"] = this.ss.getData('usuario_id');

        let qs = [];
        for(let key in params){
            let str = key + "=" + params[key];
            qs.push(str);
        }
		
        const initialState = {route: "comprasgenerales", qs: "?" + qs.join("&")};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }
    
    onPrint(){
        const initialState = {venta_id: this.ventaIdPrinted};
        this.bsModalRef = this.modalService.show(FacturaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }

    onPrintPOS(){
        if( this.Mod_FactElec ){
            if( this.tipocomprobante_id == "4" ){ // FACTURA ELECTRONICA
                this.printCbtFactElect();
            }else{ // NOTA DE VENTA
                this.printCbtNotaVenta();
            }
        }else{
            if( this.tipocomprobante_id == "1"){ //FACTURA FISICA
                this.printFacturaFisica();
            }else{ //NOTA DE VENTA
                this.printCbtNotaVenta();
            }
        }
    }

    printCbtFactElect(){
        const initialState = {route: "cbt/factelect/" + this.ventaIdPrinted, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: '', initialState}));
    }

    printCbtNotaVenta(){
        const initialState = {route: "cbt/notaventa/" + this.ventaIdPrinted, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: '', initialState}));
    }

    printFacturaFisica(){
        const initialState = {venta_id: this.ventaIdPrinted};
        this.bsModalRef = this.modalService.show(FacturaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

    }

    imprimitCbtVenta(){
        const initialState = {route: "cbtventa/" + this.ventaIdPrinted, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }

    onSend(){ 
    }

    calcularTotal(total){
        this.total_pago = total;

        //CALCULAR CAMBIO
        let saldo = this.venta.total - this.venta.abonado;

        if( this.venta.retencion ){
            saldo = saldo - this.venta.retencion.total;
        }

        this.cambio = (this.total_pago > saldo?(this.total_pago - saldo):0);
        this.cambio = this.utils.redondear(this.cambio, this.calculo_decimales);
        this.calcularCuotasCredito();
    }

    onChangeEfectivo(total){
        this.calcularCuotasCredito();
        this.valorefectivo = total;
    }

    openModalDetalle(template: TemplateRef<any>, venta_detalle) {
        this.detalle = venta_detalle.detalle;
        this.venta_detalle = venta_detalle;
        this.bsModalRef = this.modalService.show(template);
    }

    saveDetalle(){
        this.venta_detalle.detalle = this.detalle.toString().trim();
        this.detalle  = "";
        this.bsModalRef.hide();
    }

    getProforma($id){
        let arrayPromise=[];
        return new Promise((resolve, reject)=>{
            this.proformaService.getById($id, "?embed=detalle,cliente?embed=tipoidentificacion").subscribe(
                res => {
                        this.proforma = res.data;
                        this.cliente = this.proforma.cliente;
                        this.venta.bodega_id = this.proforma.bodega_id;

                        this.ventasDetalle = [];
                        this.proforma.detalle.forEach(item => {
                            let producto: any = {};
                            
                            arrayPromise.push(new Promise((resolve, reject)=>{
                                this.productoService.getWithPrice(this.venta.bodega_id, '?page=1&per_page=10&producto_id='+item.producto_id).subscribe(
                                    res => {
                                        if(res.data.length){
                                            let data1 = res.data[0];
                                            producto['unidad'] = data1.unidad;
                                            producto['codigo'] = data1.codigo;
                                            producto['cantidad_stock'] = data1.cantidad_stock;
                                            // producto['es_servicio'] = data1.es_servicio;
                                            producto['tipo_producto_id'] = data1.tipo_producto_id;
                                            producto['descripcion'] = data1.descripcion;
                                            producto['nombre'] = data1.nombre;
                                            producto['id'] = data1.id;
                                            producto['graba_iva'] =  data1.graba_iva;
                                            producto['precio'] = data1.precio;
                                            producto['cantidad'] = item.cantidad;

                                            this.sendObjectProducto(producto)
                                        }
                                        else{
                                            this.msgSweet.showMessage('error-message', "El producto no tiene stock suficiente");

                                        }
                                        
                                        resolve(true);
                                    },
                                    err => {
                                        reject(err);
                                    }
                                );
                            }));
                        });

                        Promise.all(arrayPromise).then(
                            res=> resolve(true),
                            err=>reject(err)
                        );                  
                },
                err => {
                    this.proforma = new Proforma;
                    reject(err);
                }
            );
        });
    }

    openModalCredito(template: TemplateRef<any>) {
        this.bsModalRef = this.modalService.show(template);
        this.valorefectivo = 0;
		this.cheques = [];
        this.tarjetas = [];
        this.transferencias = [];
        this.total_pago= 0;
        this.cambio = 0;
    }

    addCuota(){
        let item = new AmortizacionDetalle();
        this.amortizacion.detalle.push(item);
        this.valorefectivo = 0;
        this.cheques = [];
        this.tarjetas = [];
        this.transferencias = [];

        this.calcularCuotasCredito();
    }

    calcularCuotasCredito(){
        let saldo_credito = parseFloat(this.venta.total.toString()) - parseFloat(this.total_pago.toString());
        let valor_cuota = this.utils.redondear((saldo_credito / this.amortizacion.detalle.length), this.calculo_decimales);
        let acumulado = 0;
        let now = moment();
        let fecha = moment(now.format(), moment.ISO_8601).format();

        this.amortizacion.detalle.forEach((item,i) => {
            if( (i + 1) === this.amortizacion.detalle.length ){
                item.cuota = saldo_credito - acumulado;
                //item.cuota = Math.round(item.cuota * 100) / 100;
                item.cuota = this.utils.redondear(item.cuota, this.calculo_decimales);

                let now = moment();
                let fecha = moment(now.format(), moment.ISO_8601).add((i+1),'month').format();
                item.fecha_vencimiento = fecha;
            }else{
                acumulado += valor_cuota;
                item.cuota = valor_cuota;

                let now = moment();
                let fecha = moment(now.format(), moment.ISO_8601).add((i+1),'month').format();
                item.fecha_vencimiento = fecha;
            }
        });
    }

    removeCuota(i){
        this.amortizacion.detalle.splice(i,1);
        this.calcularCuotasCredito();
    }

    saldoCuotas(){
        return parseFloat(this.venta.total.toString()) - parseFloat(this.total_pago.toString());
    }

    getTotalCuotasCredito(){
        let total = 0;

        this.amortizacion.detalle.forEach(item => {
            total += item.cuota.toString().length === 0 ? 0 : (parseFloat(item.cuota.toString())) ;
        });

        total = this.utils.redondear(total,this.calculo_decimales);

        return total;
    }

    isValidFormCuotas(){
        let totalCuotas = this.getTotalCuotasCredito();
        let ventaTotal = this.venta.total;
        let total_abonado = this.total_pago;
        
        if( (totalCuotas + total_abonado) != ventaTotal){
            return false;
        }
        return true;
    }

    openModalPrecios(ventaDetalle: VentaDetalle){
        const initialState = { producto_id: ventaDetalle.producto_id, descripcion: ventaDetalle.producto};

        this.bsModalRef = this.modalService.show(PreciosModalComponent, Object.assign({backdrop: 'static',class: 'modal-sm', initialState}));

        this.bsModalRef.content.sendPrecio.take(1).subscribe((precio) => {
            this.PreciosAdd = precio;

            ventaDetalle.precio_unitario = parseFloat(this.PreciosAdd.valor.toString());
            ventaDetalle.subtotal = ventaDetalle.cantidad * ventaDetalle.precio_unitario;
            this.calcularFactura();
            this.calcularCuotasCredito();

        });
    }

    onChangeFecha(event){
        if(this.Mod_FactElec && event < this.fecha_MesAnt){
            this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");            
        }
    }

    onImage(producto){
		this.ruta_imagen = this.uploadfile_api + "/image/" + (producto.imagen!=""?producto.imagen:"nofoto.png") + "/300?tk=" + this.ss.getData('api-token') + "&dbname=" + this.ss.getData('dbname');

		const initialState = { title: producto.producto, ruta_image: this.ruta_imagen };
		this.bsModalRef = this.modalService.show(ImageModalComponent, Object.assign({}, {class: 'modal-sm', initialState}));
    }
    
    validarCorreo() {
		if (this.correos.length > 0) {
			let count_true = 0;
			let count_false = 0;
			for (let index = 0; index < this.correos.length; index++) {
				let res = this.correoService.isEmailValido(this.correos[index]);
				if (res) {
					count_true++;

				} else {
					count_false++;
				}

			}
			if (count_false > 0) {
				this.correo_invalid = true;
			} else {
				this.correo_invalid = false;
			}


		} else {
			this.correo_invalid = false;
		}
	}
    onChangeFormasPagoFacturacion(){
        this.venta.forma_pago_facturacion_id = this.forma_pago_facturacion_id;
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/venta-add/venta-add.component.ts